export enum ERentalType {
  RV = 'rv',
  STAY = 'stay',
  CAMPGROUND = 'campground',
  AUTO = 'auto',
  LODGING_SITE = 'lodging_site',
  RV_SITE = 'rv_site',
  TENT_SITE = 'tent_site',
  CAMPSITE = 'campsite',
  STATIONARY_CAMPER_SITE = 'stationary_camper_site',
  ESCAPE = 'escape',
}
